import { render, staticRenderFns } from "./oyatsu.vue?vue&type=template&id=411af03a&"
import script from "./oyatsu.vue?vue&type=script&lang=js&"
export * from "./oyatsu.vue?vue&type=script&lang=js&"
import style0 from "./oyatsu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,ListCase: require('/home/runner/work/myody_front/myody_front/components/list/ListCase.vue').default,TableOyatsuPrice: require('/home/runner/work/myody_front/myody_front/components/table/TableOyatsuPrice.vue').default,CardContact: require('/home/runner/work/myody_front/myody_front/components/card/CardContact.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
